<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <div class="hero-panel mb-4">
      <div
        class="mx-auto md:px-4 bg-lightest bg-center bg-no-repeat bg-cover
        bg-none-below-md"
        style="max-width: 2000px; background-image:
        url(https://via.placeholder.com/800x580);">
        <div class="w-full max-w-6xl mx-auto border-box">
          <div class="flex flex-wrap" style="min-height: 680px;">
            <div
              class="md:hidden bg-center bg-no-repeat bg-cover w-full"
              style="background-image:
              url(https://via.placeholder.com/400x300); padding-top: 60%;"></div>
            <div class="flex items-end border-box px-5 md:px-0">
              <div
                class="w-full max-w-2xl border-box bg-white transform-none-below-md rounded-lg border border-light -mt-8 md:-mt-0"
                style="transform: translateY(4rem);">
                <div class="py-5 md:py-7 px-4 md:p-7">
                  <h1 class="heading heading-2 md:heading-1">
                    Jen is now more confident with comparing health insurance
                  </h1>
                  <div class="mt-4">
                    <p class="heading heading-3">
                      Jen is now more confident with comparing health
                      insurance
                    </p>
                  </div>
                  <p class="copy my-4">
                    By using the list she wrote and learning along the way,
                    Jen feels like she has a better understanding of which
                    health cover will give her peace of mind.
                  </p>
                  <button class="button button-primary-dark">
                    Ask a question
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  const textOnly = `
  <div class="py-5 px-4 md:p-6 xl:p-7">
    <div class="container text-center space-y-4">
      <h1 class="heading heading-2 md:heading-1">
        Jen is now more confident with comparing health insurance
      </h1>
      <p class="heading heading-3">
        Jen is now more confident with comparing health
        insurance
      </p>
      <p class="copy my-4 mx-auto text-center">
        By using the list she wrote and learning along the way,
        Jen feels like she has a better understanding of which
        health cover will give her peace of mind.
      </p>
      <button class="button button-secondary-dark">
        Ask a question
      </button>
    </div>
  </div>
  `;
</script>

<template>
  <section id="hero-panel" class="page-section bg-sunsetPink40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Hero Panel</h2>
    </div>
    {@html snippet}
    <div class="container">
      <CodeSnippet id="hero-panel" {snippet} />
    </div>

    <div class="container">
      <h3 class="heading heading-3 mt-8 mb-6">Text Only Variant</h3>
    </div>
    {@html textOnly}
    <div class="container">
      <CodeSnippet id="hero-panel-text" snippet={textOnly} />
    </div>
  </section>
</template>
